namespace Serenity {

    export function setupUIOverrides() {

        Serenity.EntityGrid.prototype['getButtons'] = (function (old) {
            return function () {

                var buttons = old.call(this) as Serenity.ToolButton[];

                var addButton = Q.tryFirst(buttons, x => x.cssClass === "add-button");
                if (addButton)
                    addButton.icon = "fa-plus-circle text-green";

                var refreshButton = Q.tryFirst(buttons, x => x.cssClass === "refresh-button");
                if (refreshButton)
                    refreshButton.icon = "fa-refresh text-blue";

                var pickerButton = Q.tryFirst(buttons, x => x.cssClass === "column-picker-button");
                if (pickerButton)
                    pickerButton.icon = "fa-th-list text-blue";

                var excelButton = Q.tryFirst(buttons, x => x.cssClass === "export-xlsx-button");
                if (excelButton)
                    excelButton.icon = "fa-file-excel-o";

                return buttons;
            };
        })(Serenity.EntityGrid.prototype['getButtons']);

        Serenity.EntityDialog.prototype['getToolbarButtons'] = (function (old) {
            return function () {

                var buttons = old.call(this) as Serenity.ToolButton[];

                var saveButton = Q.tryFirst(buttons, x => x.cssClass === "save-and-close-button");
                if (saveButton)
                    saveButton.icon = "fa-floppy-o text-purple";

                var applyButton = Q.tryFirst(buttons, x => x.cssClass === "apply-changes-button");
                if (applyButton)
                    applyButton.icon = "fa-check-circle text-purple";

                var deleteButton = Q.tryFirst(buttons, x => x.cssClass === "delete-button");
                if (deleteButton)
                    deleteButton.icon = "fa-trash-o text-red";

                var cloneButton = Q.tryFirst(buttons, x => x.cssClass === "clone-button");
                if (cloneButton)
                    cloneButton.icon = "fa-clone";

                return buttons;
            };
        })(Serenity.EntityDialog.prototype['getToolbarButtons']);

        Serenity.EntityDialog.prototype['updateInterface'] = (function (old) {
            return function () {

                old.call(this);

                if (this.saveAndCloseButton) {
                    this.saveAndCloseButton.find('.button-inner')
                        .html("<i class='fa fa-floppy-o text-purple'></i> " +
                            Q.htmlEncode(Q.text((this.isNew() ? 'Controls.EntityDialog.SaveButton' :
                                'Controls.EntityDialog.UpdateButton'))));
                }
            };
        })(Serenity.EntityDialog.prototype['updateInterface']);

        $.datepicker.setDefaults({
            buttonImage: null,
            buttonImageOnly: false,
            buttonText: '<i class="fa fa-calendar"></i>'
        });

        Serenity.Toolbar.prototype['createButton'] = (function (old) {
            return function (container: JQuery, b: Serenity.ToolButton) {
                if (b.separator)
                    container = $('<div class="buttons-inner"></div>').appendTo(container.parent());
                else
                    container = container.parent().children().last();

                old.call(this, container, b);

                if (b.separator)
                    container.children().first().remove();
            }
        })(Serenity.Toolbar.prototype['createButton']);

        Serenity.ColumnPickerDialog.prototype['createLI'] = (function (old) {
            return function (col: Slick.Column) {
                var allowHide = this.allowHide(col);
                return $("\n<li data-key=\"" + col.id + "\" class=\"" + (allowHide ? "" : "cant-hide") + "\">\n  <span class=\"drag-handle\">\u2630</span>\n  " + Q.htmlEncode(this.getTitle(col)) + "\n  " + (allowHide ? "<i class=\"js-hide fa fa-eye-slash\" title=\"" + Q.text("Controls.ColumnPickerDialog.HideHint") + "\"></i>" : '') + "\n  <i class=\"js-show fa fa-eye\" title=\"" + Q.text("Controls.ColumnPickerDialog.ShowHint") + "\"></i>\n</li>");
            };
        })(Serenity.ColumnPickerDialog.prototype['createLI']);

        Serenity.ColumnPickerDialog.prototype['getTemplate'] = (function (old) {
            return function () {
                var template = old.call(this);
                return template.replace('fa-list', 'fa-eye-slash');
            };
        })(Serenity.ColumnPickerDialog.prototype['getTemplate']);

        Serenity.DataGrid.defaultRowHeight = 27;
        Serenity.DataGrid.defaultHeaderHeight = 27;
    }
}